import { JOB_TERM_COUNTRIES, JOB_TERM_DEPARTMENTS } from "@qlik/qlik/src/lib/constants/job-constants";

/**
 * Filters local jobs based on the provided filters.
 *
 * @param {Object} filters - The filters object containing page and limit properties.
 * @param {number} filters.page - The page number for pagination.
 * @param {number} filters.limit - The maximum number of jobs to fetch.
 * @param {Array} filters[JOB_TERM_DEPARTMENTS] - The departments to filter by.
 * @param {Array} filters[JOB_TERM_COUNTRIES] - The countries to filter by.
 * @return {Object} An object containing the total number of jobs and the filtered local jobs.
 */
const filterLocalJobs = (filters, jobsData) => {
    // Extract the filter parameters we need
    const { page, limit } = filters;
    const departments = filters[JOB_TERM_DEPARTMENTS];
    const countries = filters[JOB_TERM_COUNTRIES];

    // Apply pagination
    const startIndex = page * limit;
    const endIndex = startIndex + limit;

    // create a simpler array of jobs (remove the "job" and "edges" nodes)
    let filteredJobs = jobsData?.jobs?.edges.map(({ node }) => node);

    // Apply filters - departments
    if (departments.length > 0) {
        filteredJobs = filteredJobs.filter((job) => departments.includes(job.category));
    }

    // Apply filters - countries
    if (countries.length > 0) {
        filteredJobs = filteredJobs.filter((job) => countries.includes(job.locationCountry));
    }

    // Get the length of the filtered results before I start paginating
    const resultsLength = filteredJobs?.length;

    // Apply pagination
    filteredJobs = filteredJobs?.slice(startIndex, endIndex);

    // Return the total number of filtered jobs as well as the paginated results
    return {
        totalJobs: resultsLength,
        filteredLocalJobs: filteredJobs,
    };
};

export { filterLocalJobs };
